import React from 'react'
import Mobile from './mobile'

const LayoutMobileComponent = (props) => {
    return <Mobile>
        {props.children}
    </Mobile>
}
export default LayoutMobileComponent